'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-beneficiaries-picker',
  _template: html`
  <style>
  :host {
    display: block;
  }

  paper-button {
    color: var(--paper-blue-grey-500);
  }
  </style>
  <dom-module id="moskito-beneficiaries-picker">
    <link rel="stylesheet" href="moskito-beneficiaries-picker.css" />
    <template>
    <paper-button on-click="_openDialog" id="btn"><paper-icon-button icon="icons:add"></paper-icon-button>Ajouter des Bénéficiaires</paper-button>
    <iron-ajax
     	auto
     	id="ajax"
     	url="[[url]]"
     	handle-as="json"
     	on-response="_handleResponse"
     	last-response="{{data}}"></iron-ajax>
    <paper-dialog id="dialog" modal>
    	<h2>Choisissez un ou des Bénéficiaires :</h2>
    	<paper-dialog-scrollable>
    		<paper-listbox attr-for-selected="value" selected-values="{{beneficiaryIds}}" multi id="beneficiaries">
    			<template is="dom-repeat" items="{{data.children}}">
    				<paper-item value="[[item.id]]" on-click="_itemClicked">[[item.name]]</paper-item>
    			</template>
    </paper-listbox>
    </paper-dialog-scrollable>
    <div class="buttons">
        <paper-button dialog-confirm autofocus>
            <paper-icon-button icon="icons:cancel"></paper-icon-button>Fermer</paper-button>
    </div>
    </paper-dialog>
    </template>

    <script src="moskito-beneficiaries-picker.js"></script>
</dom-module>
  `,
  properties: {
    url: {
      type: String,
      notify: true
    },
    beneficiaryIds: {
      type: Array,
      notify: true
    },
    disabled: {
      type: String,
      notify: true,
      value: 'false'
    }
  },
  _itemClicked: function (e) {

  },
  _openDialog: function () {
    if (this.disabled == 'false') {
      this.$.dialog.open()
    }
  },
  _handleResponse: function (data) {},
  _dialogClosed: function () {
    this.fire('update')
  }
})
